module.exports = __webpack_public_path__ + "static/media/sst.d4e5d21c.png";